"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _priceAttributeAggregatorV = _interopRequireDefault(require("@cimpress-technology/price-attribute-aggregator-v2"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _forOwn = _interopRequireDefault(require("lodash/forOwn"));

var _keyBy = _interopRequireDefault(require("lodash/keyBy"));

var _find = _interopRequireDefault(require("lodash/find"));

var _get = _interopRequireDefault(require("lodash/get"));

var _Loading = _interopRequireDefault(require("./Loading"));

var _RuleSet = require("./RuleSet");

var _CompetitorProductsAggregatorEachForProduct = _interopRequireDefault(require("./CompetitorProductsAggregatorEachForProduct"));

var _constants = require("./constants");

require("./unionSelector.css");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var UnionSelectorEachForProduct =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(UnionSelectorEachForProduct, _PureComponent);

  var _super = _createSuper(UnionSelectorEachForProduct);

  function UnionSelectorEachForProduct(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, UnionSelectorEachForProduct);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getDefaultState", function (ruleSet) {
      return (0, _defineProperty2["default"])({}, ruleSet.referenceId, {});
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "init", function () {
      var competitorProducts = _this.props.competitorProducts;
      var competitorProductsRuleSets = [];
      (0, _forEach["default"])(competitorProducts, function (competitorProduct) {
        var competitorProductsRuleSet = (0, _RuleSet.formRuleSetForCompetitorProduct)(competitorProduct);
        competitorProductsRuleSets.push(competitorProductsRuleSet);
      });

      _this.setState({
        competitorProductsRuleSets: competitorProductsRuleSets,
        isLoading: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (competitorProductsStates) {
      var productsState = (0, _cloneDeep["default"])(_this.state.productsState);

      var newProductsState = _objectSpread(_objectSpread({}, productsState), competitorProductsStates);

      _this.setState({
        productsState: newProductsState
      }, function () {
        return _this.props.onChange(newProductsState);
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAggregatorChange", function (_ref2) {
      var resolvedAttributes = _ref2.resolvedAttributes,
          displayedAttributes = _ref2.displayedAttributes,
          selectedRow = _ref2.selectedRow,
          selectedColumn = _ref2.selectedColumn,
          state = _ref2.state,
          violations = _ref2.violations;

      if (['onLoad', 'fullyResolved'].includes(state)) {
        if (state === 'fullyResolved') {
          var productsState = (0, _cloneDeep["default"])(_this.state.productsState);
          var ruleSet = _this.props.ruleSet;
          productsState[ruleSet.referenceId] = {
            state: _constants.productState.fullyResolved,
            resolvedAttributes: resolvedAttributes
          };

          var productsAttributeConfigurations = _this.getCompProductsAttributeConfigurations(resolvedAttributes, productsState);

          if (!(0, _isEmpty["default"])(productsAttributeConfigurations)) {
            _this.setState({
              productsAttributeConfigurations: productsAttributeConfigurations
            });
          } else {
            _this.setState({
              productsState: productsState
            }, function () {
              return _this.onChange(productsState);
            });
          }
        }
      } else if (state === 'partiallyResolved') {
        var _productsState = (0, _cloneDeep["default"])(_this.state.productsState);

        var _ruleSet = _this.props.ruleSet;
        _productsState[_ruleSet.referenceId] = {
          state: _constants.productState.partiallyResolved,
          resolvedAttributes: resolvedAttributes
        };

        var _productsAttributeConfigurations = _this.getCompProductsAttributeConfigurations(resolvedAttributes, _productsState);

        if (!(0, _isEmpty["default"])(_productsAttributeConfigurations)) {
          _this.setState({
            productsAttributeConfigurations: _productsAttributeConfigurations
          });
        } else {
          _this.setState({
            productsState: _productsState
          }, function () {
            return _this.onChange(_productsState);
          });
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getCompatitorProductsAttributeSelectorsBeta", function () {
      var _this$state = _this.state,
          competitorProductsRuleSets = _this$state.competitorProductsRuleSets,
          productsAttributeConfigurations = _this$state.productsAttributeConfigurations;
      var authToken = _this.props.authToken;
      return (
        /*#__PURE__*/
        _react["default"].createElement(_CompetitorProductsAggregatorEachForProduct["default"], {
          authToken: authToken,
          competitorProductsRuleSets: competitorProductsRuleSets,
          onChange: _this.onChange,
          onReset: _this.onReset,
          onError: _this.onError,
          attributeConfigurations: productsAttributeConfigurations
        })
      );
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getCompProductsAttributeConfigurations", function (resolvedAttributes, productsState) {
      if ((0, _isEmpty["default"])(resolvedAttributes)) {
        return null;
      }

      var productsAttributeConfigurations = {};
      (0, _forOwn["default"])(productsState, function (product, productId) {
        var compProduct = (0, _keyBy["default"])(product.attributes, function (attribute) {
          return attribute.key.toLowerCase();
        });
        var result = (0, _find["default"])((0, _get["default"])(resolvedAttributes[0], 'values[0].attributes', []), function (attribute) {
          return (// Need to check both property `key` and `attributeKey` because in partially resolved state we are getting property as key
            // and in fully resolved we are getting property as attributeKey
            compProduct[(attribute.key || attribute.attributeKey).toLowerCase()] && !compProduct[(attribute.key || attribute.attributeKey).toLowerCase()].resolvedValue && attribute.resolvedValue
          );
        });

        if (result) {
          productsAttributeConfigurations[productId] = (0, _defineProperty2["default"])({}, result.key, {
            initialSelection: result.resolvedValue
          });
        }
      });
      return productsAttributeConfigurations;
    });
    _this.attributeAggregatorByRuleSetRef =
    /*#__PURE__*/
    _react["default"].createRef();
    _this.state = {
      isLoading: true,
      competitorProductsRuleSets: [],
      productsAttributeConfigurations: {},
      productsState: _this.getDefaultState(props.ruleSet)
    };
    return _this;
  }

  (0, _createClass2["default"])(UnionSelectorEachForProduct, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!(0, _isEqual["default"])(prevProps.ruleSet, this.props.ruleSet) || !(0, _isEqual["default"])(prevProps.competitorProducts, this.props.competitorProducts) || prevProps.authToken !== this.props.authToken) {
        this.init();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          authToken = _this$props.authToken,
          ruleSet = _this$props.ruleSet,
          className = _this$props.className,
          showErrorModal = _this$props.showErrorModal,
          consumerId = _this$props.consumerId;
      var isLoading = this.state.isLoading;

      if (isLoading) {
        return (
          /*#__PURE__*/
          _react["default"].createElement(_Loading["default"], null)
        );
      }

      return (
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: className
        },
        /*#__PURE__*/
        _react["default"].createElement(_priceAttributeAggregatorV["default"], {
          consumerId: consumerId,
          referenceId: ruleSet.referenceId,
          showErrorModal: showErrorModal,
          showAttributeSelectorErrorModal: true,
          authToken: authToken,
          ruleSet: ruleSet,
          hiddenAttributes: [],
          onReset: this.props.onReset // onFullyResolved={this.onFullyResolved}
          // onPartiallyResolved={this.onPartiallyResolved}
          ,
          onChange: this.onAggregatorChange // onUnresolvable={this.onUnresolvable}
          ,
          isHideDerivedAttributes: true,
          onError: this.props.onError // fnCallBackToLoadedAgain={() => {}}

        }), this.getCompatitorProductsAttributeSelectorsBeta())
      );
    }
  }]);
  return UnionSelectorEachForProduct;
}(_react.PureComponent);

exports["default"] = UnionSelectorEachForProduct;
(0, _defineProperty2["default"])(UnionSelectorEachForProduct, "propTypes", {
  onReset: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  authToken: _propTypes["default"].string.isRequired,
  ruleSet: _propTypes["default"].shape({}).isRequired,
  showErrorModal: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  competitorProducts: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    whiteList: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      attributeKey: _propTypes["default"].string.isRequired,
      attributevalue: _propTypes["default"].arrayOf(_propTypes["default"].shape({
        value: _propTypes["default"].string.isRequired,
        description: _propTypes["default"].string
      }))
    }))
  })).isRequired,
  consumerId: _propTypes["default"].string.isRequired
});
(0, _defineProperty2["default"])(UnionSelectorEachForProduct, "defaultProps", {
  onReset: function onReset() {},
  onChange: function onChange() {},
  onError: function onError() {},
  showErrorModal: true,
  className: ''
});